module.exports = __webpack_public_path__ + "static/media/bilista_logo_vertical.3dfc2a5c.svg";